// This file is auto-generated by scripts/generate-site-data.ts
// Do not edit this file manually

import type { SanitySite } from '#/lib/sanity/queries/site.ts';

export const siteData: SanitySite = {
  title: 'Transcend Agent & Data Control Platform',
  description:
    'Transcend is the only runtime agent and data control platform that uses policy-as-code to accelerate AI adoption in the enterprise. A Gartner® Magic Quadrant™ Leader.',
  openGraphTitle:
    'Transcend | The only runtime agent and data control platform',
  openGraphDescription:
    'Transcend is the only runtime agent and data control platform that uses policy-as-code to accelerate AI adoption in the enterprise. A Gartner® Magic Quadrant™ Leader.',
  openGraphImage: {
    _type: 'image',
    _id: 'image-b1556a59af9c8cbb627439396ea533faa7b01bc1-1000x500-png',
    url: 'https://cdn.sanity.io/images/ztw74qc4/production/b1556a59af9c8cbb627439396ea533faa7b01bc1-1000x500.png',
    alt: 'White transcend logo on black background',
    width: 1000,
    height: 500,
    lqip: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA20lEQVQokaVSyw6CMBDkO1ERFIKKGk008YH4RD0aP9ZdTmOWDUlVUBIPk2m37UynXavdIAgc+5FzFcz1sr2OrWyZG4Tf8c2kzNAqlIuC1yJ0HOUqkypjx37oDYtJt02YjgiLOWM6JgxCQugTAo/gu6+QmsAzjD8iRyHhcspwv2W4phl2G8Y2ZiRrxWbFiJeMZMXYJzqPwh+C5yPngiIsB0TwtOe8nh50LHxJs1w06pUImpEnEnnGmAw1bs/X6GImhyNj3A/0vWt9itv841Oq2qZuy3z0YZ3Griv4BPXIIssa2w/MAAAAAElFTkSuQmCC',
    caption: null,
    roundedCorners: false,
    captionTextAlign: null,
  },
  announcement: null,
  header: {
    primaryNavigation: [
      {
        _type: 'menu',
        _key: '5169b7a58a3d',
        title: 'Platform',
        columns: [
          {
            _key: '8bed37f53825',
            hasDivider: false,
            background: 'purple',
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: 'df1ca12e5a28',
                title: 'Enable & Control Agents',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: '91ac120318a2',
                    link: {
                      _type: 'internalLink',
                      _key: 'f841dbfd79ac',
                      title: 'New Transcend Rails',
                      href: '/rails',
                    },
                    description:
                      'The only runtime agent policy-as-code to control what they spend, browse, and deploy to automate the enterprise',
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: '48ec77114771',
            hasDivider: true,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: 'b4e9d64c0d2c',
                title: 'Activate Data & AI Responsibly',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: '20c4b2378c41',
                    link: {
                      _type: 'internalLink',
                      _key: '02e997d21bc5',
                      title: 'AI Governance',
                      href: '/solutions/ai-transformation-do-not-train',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '131a364ad698',
                    link: {
                      _type: 'internalLink',
                      _key: 'c96fe4c6beb7',
                      title: 'Policy Engine',
                      href: '/platform/policy-engine',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '925e4dc099d8',
                    link: {
                      _type: 'internalLink',
                      _key: '150b28934254',
                      title: 'Consent & Preference Management',
                      href: '/platform/consent-preference-management',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'c98fe468da7e',
                    link: {
                      _type: 'internalLink',
                      _key: '842df7514c67',
                      title: 'DSR Automation',
                      href: '/platform/dsr-automation',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '4baf7a299bec',
                    link: {
                      _type: 'internalLink',
                      _key: '410ea0d93e57',
                      title: 'Autonomous Privacy Operations',
                      href: '/platform#autonomous-privacy-operations',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: '3ebd68649365',
            hasDivider: false,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '3f9f9abcc108',
                title: 'Automate the enterprise',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: 'fe12612d14d5',
                    link: {
                      _type: 'internalLink',
                      _key: '0525571e95ff',
                      title: 'Explore the Platform',
                      href: '/platform',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'baf5de461237',
                    link: {
                      _type: 'internalLink',
                      _key: '3a1e2853042c',
                      title: 'Sombra™ Secure by Design',
                      href: '/security',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'd8269341b49f',
                    link: {
                      _type: 'externalLink',
                      _key: '518299b55c39',
                      title: 'Stack Agnostic Integrations',
                      href: 'https://transcend.io/integrations',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'e1ddd8d51491',
                    link: {
                      _type: 'internalLink',
                      _key: 'ea74275cab67',
                      title:
                        'Transcend named a Leader in inaugural Gartner® Magic Quadrant™ for Privacy UX',
                      href: '/blog/magic-quadrant-privacy-ux',
                    },
                    description: null,
                    style: 'purpleArrow',
                    icon: null,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _type: 'menu',
        _key: '74f6a79b98ff',
        title: 'Solutions',
        columns: [
          {
            _key: '448ec142b8ce',
            hasDivider: true,
            background: 'none',
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '409983d717c2',
                title: 'By team',
                icon: null,
                libraryIcon: {
                  _type: 'icon',
                  title: 'User Group',
                  svg: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M34.654 15.873a3.372 3.372 0 1 1-4.768 4.768 3.372 3.372 0 0 1 4.768-4.768M23.671 9.854a5.192 5.192 0 1 1-7.342 7.342 5.192 5.192 0 0 1 7.342-7.342m-13.557 6.019a3.372 3.372 0 1 1-4.768 4.768 3.372 3.372 0 0 1 4.768-4.768m28.22 15.794V29.84a4.166 4.166 0 0 0-4.167-4.167h-1.335M1.667 31.667V29.84a4.166 4.166 0 0 1 4.166-4.167h1.335m21.73 5.994v-2.669a5.833 5.833 0 0 0-5.833-5.833h-6.132a5.833 5.833 0 0 0-5.833 5.833v2.669"/>\n</svg>\n',
                },
                description: null,
                items: [
                  {
                    _key: '6c78b0c34304',
                    link: {
                      _type: 'internalLink',
                      _key: '78f56e43a81b',
                      title: 'IT & AI Infrastructure',
                      href: '/solutions/by-team/cio-it',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'ce2d4f9af0d7',
                    link: {
                      _type: 'internalLink',
                      _key: '580cb43c56d0',
                      title: 'Engineering & Product',
                      href: '/solutions/by-team/engineering-product',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '278f868be2b4',
                    link: {
                      _type: 'internalLink',
                      _key: '63741b1edb99',
                      title: 'Data & Analytics',
                      href: '/solutions/by-team/data-analytics',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'ef34750c194a',
                    link: {
                      _type: 'internalLink',
                      _key: '0f7620b15309',
                      title: 'Digital & MarTech',
                      href: '/solutions/by-team/digital-martech',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'bbbc036619cc',
                    link: {
                      _type: 'internalLink',
                      _key: 'f02b46bff501',
                      title: 'Privacy, Legal & Risk',
                      href: '/solutions/by-team/privacy-legal-risk',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: '5989161b5c28',
            hasDivider: true,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: 'dec646875688',
                title: 'By Use Case',
                icon: null,
                libraryIcon: {
                  _type: 'icon',
                  title: 'User Profile',
                  svg: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M16.818 13.598a3.75 3.75 0 1 1-5.304 5.304 3.75 3.75 0 0 1 5.304-5.304"/>\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M3.333 30.833V9.235a3.402 3.402 0 0 1 3.402-3.402h26.598a3.332 3.332 0 0 1 3.333 3.334v21.666a3.332 3.332 0 0 1-3.333 3.334H6.666a3.332 3.332 0 0 1-3.333-3.334Z" clip-rule="evenodd"/>\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M25 15.833h6.667M29 22.5h-4m-4.842 5a5.282 5.282 0 0 0-1.32-1.924v0a5.287 5.287 0 0 0-3.595-1.41H13.09a5.287 5.287 0 0 0-3.595 1.41v0a5.283 5.283 0 0 0-1.32 1.924"/>\n</svg>\n',
                },
                description: null,
                items: [
                  {
                    _key: '4aef0c9352ee',
                    link: {
                      _type: 'internalLink',
                      _key: '0107150eef2c',
                      title: 'AI Agent Management',
                      href: '/solutions/by-use-case/ai-agent-management',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '3cea07c2dc8a',
                    link: {
                      _type: 'internalLink',
                      _key: '38eed5553a7d',
                      title: 'AI Transformation / Do Not Train',
                      href: '/solutions/ai-transformation-do-not-train',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '54a6e779c94a',
                    link: {
                      _type: 'internalLink',
                      _key: 'b6bde66553e8',
                      title: 'Personalization & Audience Activation',
                      href: '/solutions/personalization-audience-activation',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'c15b2b578d8d',
                    link: {
                      _type: 'internalLink',
                      _key: '7267ad5b61bf',
                      title: 'Retail Media Networks',
                      href: '/solutions/retail-media-networks',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'd3ed2cac7310',
                    link: {
                      _type: 'internalLink',
                      _key: '09a925f5b46b',
                      title: 'Loyalty & Multi-Brand Programs',
                      href: '/solutions/loyalty-multi-brand',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'a667fedbb74c',
                    link: {
                      _type: 'internalLink',
                      _key: '01cce460187e',
                      title: 'Regulated & Sensitive Data Use',
                      href: '/solutions/regulated-sensitive-data-use',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: '3a4fff053d08',
            hasDivider: false,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '529f72b06a8c',
                title: 'By Company Type',
                icon: null,
                libraryIcon: {
                  _type: 'icon',
                  title: 'Globe',
                  svg: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M20 5c8.303 0 15 6.697 15 15s-6.697 15-15 15m0 0c-8.303 0-15-6.697-15-15S11.697 5 20 5"/>\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M16.947 6.767c-4.817 8.041-4.817 18.426 0 26.468a3.524 3.524 0 0 0 6.108 0c4.817-8.042 4.817-18.427 0-26.468-1.412-2.355-4.698-2.355-6.108 0Z" clip-rule="evenodd"/>\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6.683 13.097c8.153 2.518 18.48 2.518 26.632 0m.002 13.806c-8.154-2.518-18.48-2.518-26.632 0"/>\n</svg>\n',
                },
                description: null,
                items: [
                  {
                    _key: '327f7595c16c',
                    link: {
                      _type: 'internalLink',
                      _key: 'eed7e5bd0b6f',
                      title: 'AI governance',
                      href: '/solutions/ai',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'a01ddd82e96d',
                    link: {
                      _type: 'internalLink',
                      _key: '77df77c1c567',
                      title: 'Consumer Brands',
                      href: '/solutions/consumer',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '84012b3dec6d',
                    link: {
                      _type: 'internalLink',
                      _key: '536f8a60fd32',
                      title: 'Healthcare',
                      href: '/solutions/healthcare',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '6408577e55b0',
                    link: {
                      _type: 'internalLink',
                      _key: '0a4ac988cc57',
                      title: 'Fintech',
                      href: '/solutions/fintech',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '8d26942d2aef',
                    link: {
                      _type: 'internalLink',
                      _key: 'cbb929bbc044',
                      title: 'Media & Streaming',
                      href: '/solutions/media',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'a4aab4501dda',
                    link: {
                      _type: 'internalLink',
                      _key: '89f90678ac85',
                      title: 'B2B Companies',
                      href: '/solutions/b2b',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: '8999741681d8',
            hasDivider: false,
            background: 'lightPurple',
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '4b577d2a7b1b',
                title: 'Compare',
                icon: null,
                libraryIcon: {
                  _type: 'icon',
                  title: 'Refresh Checkmark',
                  svg: '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m25.37 16.435-6.482 6.482L15 19.028m6.817-9.861 2.5-2.5-2.5-2.5m-3.633 26.667-2.5 2.5 2.5 2.5"/>\n  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M29.457 10.618A13.274 13.274 0 0 1 33.334 20c0 7.363-5.97 13.333-13.333 13.333-1.31 0-2.572-.196-3.769-.548m-5.808-3.515A13.285 13.285 0 0 1 6.667 20c0-7.363 5.97-13.333 13.333-13.333 1.31 0 2.572.196 3.769.548"/>\n</svg>\n',
                },
                description: null,
                items: [
                  {
                    _key: '7934b5df84ef',
                    link: {
                      _type: 'internalLink',
                      _key: '22a2375e78c3',
                      title: 'Switch to Transcend',
                      href: '/switch-to-transcend',
                    },
                    description:
                      'Switching off legacy solutions is simpler than you think, and our engineers handle every step.',
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '2859e0d11342',
                    link: {
                      _type: 'internalLink',
                      _key: '27c4e92cea0c',
                      title: 'Managing Agents at Scale',
                      href: '/managing-agents',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _type: 'menu',
        _key: 'c5754242768e',
        title: 'Partners',
        columns: [
          {
            _key: 'b2dde5251133',
            hasDivider: false,
            background: 'lightPurple',
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: 'bb25d79dc23d',
                title: 'Transcend Unlock',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: '4a4b0b7430e9',
                    link: {
                      _type: 'internalLink',
                      _key: '9aff1bbf3a99',
                      title: 'Become a Partner',
                      href: '/partners/become',
                    },
                    description:
                      'Learn what the Transcend Unlock partner program can do for you.',
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: '8fde0c8400c8',
            hasDivider: true,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '4ceba69902de',
                title: 'Partner Types',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: 'f82d470590f1',
                    link: {
                      _type: 'internalLink',
                      _key: '88cffedd63d1',
                      title: 'Technology Partners',
                      href: '/partners/technology',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '4347321b0306',
                    link: {
                      _type: 'internalLink',
                      _key: '62e088f957c6',
                      title: 'Solution Partners',
                      href: '/partners/solutions',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        _type: 'menu',
        _key: '654de5b52410',
        title: 'Resources',
        columns: [
          {
            _key: '292012d49ed3',
            hasDivider: true,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '7f1ec09a94d7',
                title: 'Discover',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: 'a03a9dc99cb6',
                    link: {
                      _type: 'internalLink',
                      _key: '932e036326c6',
                      title: 'Best Practices',
                      href: '/resources',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '20e3857a07d6',
                    link: {
                      _type: 'internalLink',
                      _key: 'f98132ac4ed8',
                      title: 'Customer Stories',
                      href: '/case-studies',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '83d77250811b',
                    link: {
                      _type: 'internalLink',
                      _key: '81bbd5cb3dff',
                      title: 'Events',
                      href: '/events',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '3f12e3d8e7f6',
                    link: {
                      _type: 'internalLink',
                      _key: 'e974f7d20173',
                      title: 'Podcasts',
                      href: '/resources/categories/podcasts',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '6841fe25fc72',
                    link: {
                      _type: 'internalLink',
                      _key: '42615d4ddc88',
                      title: 'Blog',
                      href: '/blog',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '3d45ece82aec',
                    link: {
                      _type: 'internalLink',
                      _key: '730e2a2ce70d',
                      title: 'Data Governance Glossary',
                      href: '/glossary',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: 'bab6e90917dc',
            hasDivider: false,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'linkGroup',
                _key: '6c8cf723beff',
                title: 'Company',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: '2b8815334b99',
                    link: {
                      _type: 'internalLink',
                      _key: '9f843c57adbd',
                      title: 'About Us',
                      href: '/about',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '3a43837329ec',
                    link: {
                      _type: 'internalLink',
                      _key: '1185fdf4da3b',
                      title: 'Careers',
                      href: '/careers',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: '0a61ccc3cf5d',
                    link: {
                      _type: 'internalLink',
                      _key: '112095e9cbe3',
                      title: 'Press',
                      href: '/press',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
              {
                _type: 'linkGroup',
                _key: '9d51c1808a86',
                title: 'Developers',
                icon: null,
                libraryIcon: null,
                description: null,
                items: [
                  {
                    _key: '2621e03fe10f',
                    link: {
                      _type: 'externalLink',
                      _key: 'c073f25cdff6',
                      title: 'Docs',
                      href: 'https://docs.transcend.io',
                      target: '_blank',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                  {
                    _key: 'd73555ed5946',
                    link: {
                      _type: 'internalLink',
                      _key: '629bff3228f5',
                      title: 'Open Source',
                      href: '/open-source',
                    },
                    description: null,
                    style: 'default',
                    icon: null,
                  },
                ],
              },
            ],
          },
          {
            _key: 'a303226dba34',
            hasDivider: false,
            background: null,
            textLink: null,
            sections: [
              {
                _type: 'featuredContent',
                _key: '60233c8b9951',
                href: '/resources/agents-on-rails',
                headline: null,
                excerpt: null,
                thumbnailImage: null,
                referenceTitle: 'Agents on Rails',
                referenceThumbnailImage: {
                  _type: 'image',
                  _id: 'image-3f1c18b9301a3db26fae7e73e101906f0f9ceae0-1024x576-png',
                  url: 'https://cdn.sanity.io/images/ztw74qc4/production/3f1c18b9301a3db26fae7e73e101906f0f9ceae0-1024x576.png',
                  alt: "White paper cover titled 'Agents on Rails: An architecture for confidently scaling autonomous AI agents in production'.",
                  width: 1024,
                  height: 576,
                  lqip: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3klEQVQokXWSy27TQBhG8x6N7Zl4PJOMbeI0IalzJcRJmqogUPfwBEjsUTdFKiwqIcRlQ8WiC1bwBDzcQZ6kCVXTxdFcpDn/zP9NRYiUh0kIhMGvhQShIogihNYIXUcaizQptXoLZXpEeoBSXSpRNOAhlOohajG+DJ3UUYqVJlAGEVlklBLqNpHpE+k+FWufsaWxYbM2ZoaspXiBxAvEehQlNXwR4guFLzUiTAhVe33DrPma/bzC2lOkTKl6/obgHp5fFgtda4SwVLqdt+zjcfsNSfwSKRN8vzzoU63e4nFw4P23DvBKuSeoDPIL7vOevPeONDlDqRRrG8RxTBRphKgRBBLfF05S3UrXVKbjrzwZf7nDdPyNUf+SND7DmEf0ejmTyZSjoz5Z1qbZbDkajdgVuCNczH6xj8noE4l9gdYpnU7OcPiUwaCUjujnY8bjKXk+xBjrnroVrhZ/WBY3LIprlvNrFsVPlvO10NoTtI7Jmh2yrEez2aWVHdE+7NPtjhxJcoiUkeujE54c/2Y+u6KYnTMvzilmFyyK74yGH6nXZyilsTZxNwlDgwrrKNXAmLK3LTcKoXbC56d/WS1/sFxecez4zGpxw2jwwX3uMmEpd0HcplrO18GUe7tw/gG9zF8bquVoTQAAAABJRU5ErkJggg==',
                  caption: null,
                  roundedCorners: false,
                  captionTextAlign: null,
                },
                referenceExcerpt:
                  'A practical architecture for governing agent actions at runtime, so enterprises can move from sandboxed pilots to autonomous AI in production.',
                referenceType: 'resource',
                cardBadge: 'Guide',
                ctaLabel: null,
              },
            ],
          },
        ],
      },
    ],
    secondaryNavigation: [
      {
        _type: 'externalLink',
        _key: '0dcdb5119fd2',
        title: 'Docs',
        href: 'https://docs.transcend.io/docs',
        target: '_blank',
      },
      {
        _type: 'externalLink',
        _key: '5e1b0b832c16',
        title: 'Log in',
        href: 'https://app.transcend.io/login',
        target: '_blank',
      },
      {
        _type: 'internalLink',
        _key: 'd2b10f856c6d',
        title: 'Get a demo',
        href: '/contact',
      },
    ],
  },
  footer: {
    newsletter: {
      headline: 'Stay up to date on data decisioning best practices',
      bodyCopy:
        'Sign up below for periodic updates on our latest content and product releases.',
      emailInputPlaceholder: 'Email address',
      submitButtonLabel: 'Submit',
      legalText: [
        {
          _type: 'block',
          _key: 'ca0776f9a83a',
          children: [
            {
              _key: '51f61b7e9a4d0',
              _type: 'span',
              marks: [],
              text: 'By clicking the arrow above, you agree to the processing of your personal data by Transcend as described in our ',
            },
            {
              _key: '91d7f384e4c8',
              _type: 'span',
              marks: ['aa87ce2aa7b1'],
              text: 'Data Practices and Privacy Policy',
            },
            {
              _key: '113af060fc60',
              _type: 'span',
              marks: [],
              text: '. You can unsubscribe at any time.',
            },
          ],
          markDefs: [
            {
              _key: 'aa87ce2aa7b1',
              _type: 'externalLink',
              href: 'https://privacy.transcend.io',
              target: '_blank',
              title: null,
            },
          ],
          style: 'normal',
        },
      ],
      trackingEventName: 'Contact Form Submitted',
      hubspotCampaignId: '8a7703b5-4af3-40bf-bca9-0cb11b73e365',
      hubspotConvertingFormType: 'newsletter',
      hubspotEmailSubscriptionIds: null,
      confirmation: 'Thanks for signing up!',
    },
    recaptchaNotice: [
      {
        _type: 'block',
        _key: '144c62fb7ed7',
        children: [
          {
            _key: 'c7a85d9031bc0',
            _type: 'span',
            marks: [],
            text: 'This site is protected by reCAPTCHA and the Google ',
          },
          {
            _key: '8195e95408c1',
            _type: 'span',
            marks: ['82a3d28c9aad'],
            text: 'Privacy Policy',
          },
          {
            _key: '16058ea29cc4',
            _type: 'span',
            marks: [],
            text: ' and ',
          },
          {
            _key: '759425b3dc8d',
            _type: 'span',
            marks: ['3467f01e46e1'],
            text: 'Terms of Service',
          },
          {
            _key: 'ec4395a5140b',
            _type: 'span',
            marks: [],
            text: ' apply.',
          },
        ],
        markDefs: [
          {
            _key: '82a3d28c9aad',
            _type: 'externalLink',
            href: 'https://policies.google.com/privacy',
            target: '_blank',
            title: null,
          },
          {
            _key: '3467f01e46e1',
            _type: 'externalLink',
            href: 'https://policies.google.com/terms',
            target: '_blank',
            title: null,
          },
        ],
        style: 'normal',
      },
    ],
    linkGroups: [
      {
        _key: '56ca50b772ea',
        title: 'Platform',
        links: [
          {
            _type: 'internalLink',
            _key: 'e7630e28c2a7',
            title: 'New Transcend Rails',
            href: '/rails',
          },
          {
            _type: 'internalLink',
            _key: '9d83e189fc1d',
            title: 'AI Governance',
            href: '/solutions/ai-transformation-do-not-train',
          },
          {
            _type: 'internalLink',
            _key: '83069b41d9c2',
            title: 'Policy Engine',
            href: '/platform/policy-engine',
          },
          {
            _type: 'internalLink',
            _key: '85e440d22e0f',
            title: 'Consent & Preference Management',
            href: '/platform/consent-preference-management',
          },
          {
            _type: 'internalLink',
            _key: '4c12f6a2b161',
            title: 'DSR Automation',
            href: '/platform/dsr-automation',
          },
          {
            _type: 'internalLink',
            _key: 'c70ffe1f32dc',
            title: 'Autonomous Privacy Operations',
            href: '/platform#autonomous-privacy-operations',
          },
          {
            _type: 'internalLink',
            _key: 'ec0eb4f5947e',
            title: 'Explore the Platform',
            href: '/platform',
          },
          {
            _type: 'internalLink',
            _key: 'e918fb20cd2e',
            title: 'Sombra Secure-by-Design',
            href: '/security',
          },
          {
            _type: 'externalLink',
            _key: '5becb80be8a5',
            title: 'Integrations',
            href: 'https://transcend.io/integrations',
            target: '_blank',
          },
        ],
      },
      {
        _key: '385fc2bc1275',
        title: 'By Team',
        links: [
          {
            _type: 'internalLink',
            _key: 'f09da5e3feb1',
            title: 'IT & AI Infrastructure',
            href: '/solutions/by-team/cio-it',
          },
          {
            _type: 'internalLink',
            _key: '7f131551c269',
            title: 'Engineering & Product',
            href: '/solutions/by-team/engineering-product',
          },
          {
            _type: 'internalLink',
            _key: 'e790a206f9e6',
            title: 'Data & Analytics',
            href: '/solutions/by-team/data-analytics',
          },
          {
            _type: 'internalLink',
            _key: 'ac59a0e73758',
            title: 'Digital & MarTech',
            href: '/solutions/by-team/digital-martech',
          },
          {
            _type: 'internalLink',
            _key: '8821a8506402',
            title: 'Privacy, Legal & Risk',
            href: '/solutions/by-team/privacy-legal-risk',
          },
        ],
      },
      {
        _key: 'a48efd3e3cce',
        title: 'By Use Case',
        links: [
          {
            _type: 'internalLink',
            _key: '3e5f29aa5ff2',
            title: 'AI Agent Management',
            href: '/solutions/by-use-case/ai-agent-management',
          },
          {
            _type: 'internalLink',
            _key: '9f299d37e229',
            title: 'AI Transformation / Do Not Train',
            href: '/solutions/ai-transformation-do-not-train',
          },
          {
            _type: 'internalLink',
            _key: 'a4af76349aa1',
            title: 'Personalization & Audience Activation',
            href: '/solutions/personalization-audience-activation',
          },
          {
            _type: 'internalLink',
            _key: '63b79cba1d84',
            title: 'Retail Media Networks',
            href: '/solutions/retail-media-networks',
          },
          {
            _type: 'internalLink',
            _key: 'dc683b597332',
            title: 'Loyalty & Multi-Brand Programs',
            href: '/solutions/loyalty-multi-brand',
          },
          {
            _type: 'internalLink',
            _key: '18276814524d',
            title: 'Regulated & Sensitive Data Use',
            href: '/solutions/regulated-sensitive-data-use',
          },
        ],
      },
      {
        _key: '1b51096d7cc3',
        title: 'By Company Type',
        links: [
          {
            _type: 'internalLink',
            _key: '28f82729d118',
            title: 'AI governance',
            href: '/solutions/ai',
          },
          {
            _type: 'internalLink',
            _key: '187a1addf58e',
            title: 'Consumer Brands',
            href: '/solutions/consumer',
          },
          {
            _type: 'internalLink',
            _key: '9ad508cbaac9',
            title: 'Healthcare',
            href: '/solutions/healthcare',
          },
          {
            _type: 'internalLink',
            _key: '56bfcc4db1e5',
            title: 'Fintech',
            href: '/solutions/fintech',
          },
          {
            _type: 'internalLink',
            _key: 'ceab1c7a04c8',
            title: 'Media & Streaming',
            href: '/solutions/media',
          },
          {
            _type: 'internalLink',
            _key: '83e783b89519',
            title: 'B2B Companies',
            href: '/solutions/b2b',
          },
        ],
      },
      {
        _key: '80e53c59a401',
        title: 'Compare',
        links: [
          {
            _type: 'internalLink',
            _key: '930af780a1ec',
            title: 'Switch to Transcend',
            href: '/switch-to-transcend',
          },
          {
            _type: 'internalLink',
            _key: 'aec807a347db',
            title: 'Managing Agents at Scale',
            href: '/managing-agents',
          },
        ],
      },
      {
        _key: '313291e18601',
        title: 'Partners',
        links: [
          {
            _type: 'internalLink',
            _key: '6a7fa3873d73',
            title: 'Become a Partner',
            href: '/partners/become',
          },
          {
            _type: 'internalLink',
            _key: 'd738a1fbc242',
            title: 'Technology Partners',
            href: '/partners/technology',
          },
          {
            _type: 'internalLink',
            _key: 'ca703229d882',
            title: 'Solution Partners',
            href: '/partners/solutions',
          },
          {
            _type: 'externalLink',
            _key: 'b5cb916ac4ef',
            title: 'Partner Directory',
            href: 'https://transcend.io/partner-directory',
            target: '_blank',
          },
          {
            _type: 'externalLink',
            _key: '5188cb90d6ce',
            title: 'Login to the Partner Portal',
            href: 'https://eulerapp.com/signin',
            target: '_blank',
          },
        ],
      },
      {
        _key: '2708884b109d',
        title: 'Resources',
        links: [
          {
            _type: 'internalLink',
            _key: '38dc82f30e4e',
            title: 'Best practices',
            href: '/resources',
          },
          {
            _type: 'internalLink',
            _key: '7deace52b301',
            title: 'Customer stories',
            href: '/case-studies',
          },
          {
            _type: 'internalLink',
            _key: 'b33cafc9cdc4',
            title: 'Events',
            href: '/events',
          },
          {
            _type: 'internalLink',
            _key: '71d7750d26a6',
            title: 'Podcasts',
            href: '/resources/categories/podcasts',
          },
          {
            _type: 'internalLink',
            _key: 'fd013f457da1',
            title: 'Blog',
            href: '/blog',
          },
          {
            _type: 'internalLink',
            _key: 'bdd61c868cba',
            title: 'Data Governance Glossary',
            href: '/glossary',
          },
        ],
      },
      {
        _key: 'fc6887e8f860',
        title: 'Company',
        links: [
          {
            _type: 'internalLink',
            _key: '80c345bc2a84',
            title: 'About Us',
            href: '/about',
          },
          {
            _type: 'internalLink',
            _key: 'ec3ace607382',
            title: 'Press',
            href: '/press',
          },
          {
            _type: 'internalLink',
            _key: 'ee991e38a2cd',
            title: 'Contact us',
            href: '/contact',
          },
          {
            _type: 'internalLink',
            _key: 'f3fc02c5230b',
            title: 'Careers',
            href: '/careers',
          },
          {
            _type: 'internalLink',
            _key: '34218cff4399',
            title: 'Legal',
            href: '/legal',
          },
        ],
      },
      {
        _key: '86ea8742f31a',
        title: 'Developers',
        links: [
          {
            _type: 'internalLink',
            _key: 'e677e48b76f5',
            title: 'Open Source',
            href: '/open-source',
          },
          {
            _type: 'externalLink',
            _key: '22ba884a685a',
            title: 'Docs',
            href: 'https://docs.transcend.io',
            target: '_blank',
          },
          {
            _type: 'externalLink',
            _key: '99837e99692a',
            title: 'Platform Status',
            href: 'https://status.transcend.io',
            target: '_blank',
          },
        ],
      },
    ],
    secondaryLinks: [
      {
        _type: 'externalLink',
        _key: 'f6b22a64c6e2',
        title: 'Privacy Center',
        href: 'https://privacy.transcend.io/policies',
        target: '_blank',
      },
      {
        _type: 'externalLink',
        _key: 'e734040f2b33',
        title: 'Support',
        href: 'mailto:support@transcend.io',
      },
      {
        _type: 'externalLink',
        _key: 'd31e6184559c',
        title: 'Log in',
        href: 'https://app.transcend.io/login',
        target: '_blank',
      },
    ],
    copyrightText: 'Copyright © {year} Transcend Inc.',
    location: 'San Francisco, California',
    socialLinks: [
      {
        _key: '3a3df541b2fa',
        title: 'Linkedin',
        icon: {
          _type: 'image',
          _id: 'image-43689b1b49273feb5bd8ca37b4df6fc41901d8ed-24x24-svg',
          url: 'https://cdn.sanity.io/images/ztw74qc4/production/43689b1b49273feb5bd8ca37b4df6fc41901d8ed-24x24.svg',
          alt: 'LinkedIn logo with a gray "in" symbol inside a square.',
          width: 24,
          height: 24,
          lqip: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAACcUlEQVR4nNWUTYiNcRTGL0NGZsZnM2YmE7PAghEJKYqaWCgLFhYWFj4KIxLJ5lKUbGYxxc7NYja3NF933v//Oed/33PeuR8z6SolE0XTbCmxkETS8TG5K83Fwn/9vL+ec97nOanUv3qZTKY+hPEWomJbNisN6XR67h/ApD6E0AXEpwG5NDqa38vMi2sG5nKyEojPEEmJSJ8Cca9z+XU1A0MI7d7LFSJ9RqSviDQDyIaagSLS4H3oBuI+IrkPyLEQQkvNwEqlMt85We297HcuPhhFoatYLDZG0UQTc6Ejl+NOW8vwsKxgLnR6n9/ErBu9T1aVy+WFqVRqThUwiqIm78MeIr0KJDcAOZLLFTqJZAeglwG56b2cJQrHAbnFLP02ienz+WSnTVgFHBoKLYCeJtIJ2yOgvXE8th2Qo4CMESVTgDwikgqzThPpO2Z9a1pm7TW32Wy2bgboXNJqcQH0JbO+AfReCLqLSE4AMsmcfGZOvgEAHSfSJwYlSj6ZCUAOV7n8HZBIvxDpCyCx0Q8Aeg6Qh8zJRyJ9ziw9QKl5NkBzIt5rt4jUO5dsAaT/h+sp22UI5fbZAD8AMkQkW03vvawH9A5R8tp26n2ctjTMYof6HpAH5sz0zGNrAe2zEjDrNCDX/jMgUGoG9CSRJsz62Hu97X3YZgEHlJmTSUDv/uw3kKxxTq4DatksEcl5O3szQLt/1grn7OLEFy0aw8PcEUW8GYhPWVu8jw9Z/b7/lPIy5+J9gFzwPt8D5HdbTX8BZusGB4uN9gERteVyhaVRFC0AsMiOxMhIaGfm5dZ504vIvIEBWWJa51yrVbeqKX/zfQVpcJpsKbNrIAAAAABJRU5ErkJggg==',
          caption: null,
          roundedCorners: false,
          captionTextAlign: null,
        },
        href: 'https://www.linkedin.com/company/transcend-io/',
      },
      {
        _key: '08fd3ea9ecdb',
        title: 'Github',
        icon: {
          _type: 'image',
          _id: 'image-89b297980041e2de36dc7b42b9eb97d8af60d2f3-24x24-svg',
          url: 'https://cdn.sanity.io/images/ztw74qc4/production/89b297980041e2de36dc7b42b9eb97d8af60d2f3-24x24.svg',
          alt: 'A black and white GitHub logo consisting of a stylized silhouette of a cat with octopus-like tentacles, known as "Octocat."',
          width: 24,
          height: 24,
          lqip: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAADcElEQVR4nJVVXYhVVRQ+WZE+TAWFmJL2BxXSQyQIiUXRq/VQ1ERU9EeKFr0WwqWg6SH6eYhII6Kgwlvj3PLcc/b3rXP2Wnu62YNDRD8W+qJiY1QjlpL2M06se++MI92iFizu4ex1vr3Wt761bpbNs0ajsaDV6gzlOa8GqjtIGxHRUcDM3Z9DiCMi8XaP8dhGo7EgG2SqetaOHdUywNaR9mIfYA9pk6T91PdJf+dnHkParVVVLfNvTwObmJg4O88/vgyIj5KxELHvSPtdJM0Mcj9zcMDKEHRDUdSXO0YXrNlsnpnn9YoQdBNpqQ/2PWlHSZseADZN2i9k8phDpI6TuklEljuWl3p+CPEuwCqR8UlSHfQ10j4gbYK0z0XSLnd/BmwXGd8ndQupHb8c0Kos6zsdKyN1FWCvk+lHMh0UsZeqytYCcQ2gw1Wlw85Vz/XuotDhEOrryXgjaa94liL2A2Bb221dlYVQP9a7Pf1B2j6RtDmEdLFz0ul0hlqt1pCqLnT3rrr7WV3XK0TS0yJ2wL/1zIG0MQPiNqDL2zSgX5D68PbtcsFAKZyuigvJtJ60r0SS83qQtPcyEd3dI9l+BTQH6hvmOvYv5jEh2E2klWQ67hiAfp2Rdrgvg8OAvlGW9crsP5qIXUOmt0TsiEj6jbQpf3lMxP7sAaf/DQikt0XSkX4PjmVAt0snvGRSP/Lu/k35A8xjnB4yFb2S03HvhZfsWprqC/ZLIG70EeyK9B/Mz1wJpD4BpN39pky5yF2HLwDdmf2ZtG9JawLxIRG7NqV0UVEU58zLaiHZWQrE60KoN7igSTsqkk6KpD1AfD4ry3gboG1vP6AtQD8kFSK2ldR7SS6dmZk5w31srJvVA2R8k9TPRLpJnOwpxEqgWpeVpV4C6JNkGu+NVBwB9B0yjnlJPqOzGYagVwH6sojt9yb0Zjv57zekPeViz7ykGMdX+xiJWADqZ0OoHwHi/T5iRVGcOw/wCqdIJB2aBSPtgIi9CsTVc/T4iJWl3uK3u9pDiL4PHy9LW9tsynmzgAAu9aXrUyGSTpBpL6Bb6jrd7BhzXXN+PJP+QtgskraJ2Lsi9mCe65JTupPlTg8QPxXpLtln2u24xsEcY4Acdi5ynpx4EXvOt8voKBafyvCTxSHEe3p/A/V9ZVlf2Ww2F80H+Qsb5mJNvB/MZgAAAABJRU5ErkJggg==',
          caption: null,
          roundedCorners: false,
          captionTextAlign: null,
        },
        href: 'https://github.com/transcend-io',
      },
      {
        _key: '82e8721988a3',
        title: 'X',
        icon: {
          _type: 'image',
          _id: 'image-37ab24758a303bad9cbfd609cd3f0d452c4ddc57-27x24-svg',
          url: 'https://cdn.sanity.io/images/ztw74qc4/production/37ab24758a303bad9cbfd609cd3f0d452c4ddc57-27x24.svg',
          alt: null,
          width: 27,
          height: 24,
          lqip: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAPoAAAD6AG1e1JrAAADlklEQVQ4jX2UW2gdVRSGT9po1LYS0YLog+IFkeC1PkgRiuiLSkGKINp4gUKtDyrFFnuBHqVQK8EiFsQQI33xwsFy4mk7JzN7r/WvvdfeM5MQJWhosVRBEDHgm4Loy5GdnJbQQvbTwMz+Z63v/9dqMOvnQLxA5P9j1n+cK/9yrvqNWce7XffwwsLC1b1eb6DRP+kZwPqikKeZ9QwQFpm1a61snZoKGxpEso05tABdJHK/WutgrQZrnSXyr1tb3trr9dZeFG21WtcWBR4RicdEwjlmnbFW3yaiO8fH565qnD6Nm5ndK4ASs//OGHe0KOQdZt8RST/yzwIY7vV6awBcY62/nzkcdq6cB8L3zP5Qt0sjqZOlFgAMquodQNjrXGWdqyat9aOA7g+h7jpXfkIUN9d1fX1RyL3WykEgzomUPwJ61Bh5KP2o0WhcwtLIsmwIwIOqMx+EMEveV2NE8qL35ZhqlYuUhxMzY7CX2Vci5TmicLwo8Gin07luJeNLoFut1nrm+IRIPJEqZfYHlisNk85FZvYnk5hz4bxz5aS14fGpqakNV4j1z0Cz2VyTZX5jqoxZTwGxY23YZYzsFAmngJCc/z0Ji+hWVb0h3WmsbPXyk3gCuJ3I71atjPf1CcC/BMR9InGOOZy11h9M36x0ftWT3DJG7hOJR1Rn2Pv6I+awXSSMOVf6xHd6Wh/ouzqwulqfZ5ZlydFtIuW0aj0rUh4C/KhINaFad5n1LSK6rdlsDq4q2p+CwaIIt1jrXkuhFYl/igQQ+TeYdScQToqENrN73hhz46ptL4d37iZr/XOAfgvEn5nDQgqwc/ELwL1KtJTXrvfVhPfllk5n7srYXKyu3cZwnstTzPqlSHkB0JxI9zGHsRhnC++r40AY9b5+P8bZPITqSJqcK3gmsTzP12UZbyHSCZHyJ5Eo1rpdRSF3E7nNzlUfq9Y2hZxIX/a++jTxJPK7k+sJ1ZLosgnnh/JcNzG7Y0A8C4QZIt0DlHelKWq328PM8RlAvwZiTuT2LPOM36SZN4a3Z1m2MSFbGjsiHSHSd0ViGvh5IvceEY2kd/0pWpuWiLVuB5FOM4e2tXLAGPmMWX9IiIzBk3k+v67R7dI9QKomzKbqiPTDPOdNaeBXwk6rqd/+fiB6IMSUAkD/AMIv6V5aa42iwAsJvki5aK0/k0xJPC93rp/PIWPwGLN+5X296H35N7P/Ny1molAbI2/+DyPRI0zaUPAtAAAAAElFTkSuQmCC',
          caption: null,
          roundedCorners: false,
          captionTextAlign: null,
        },
        href: 'https://x.com/transcend_io',
      },
    ],
  },
} as const;

export default siteData;
